import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CoreModule } from '../../core.module';
import { RequestLoaderComponent } from './request-loader.component';

@NgModule({
  declarations: [RequestLoaderComponent],
  imports: [CoreModule, MatProgressBarModule],
  exports: [RequestLoaderComponent],
})
export class RequestLoaderModule {}
